export default __webpack_public_path__ + "static/media/spriteList.752b6953.svg";